import React, { useState, useMemo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useGetNotificationUnreadCount, useGetNotifications } from 'modules/notification/api/queries' // <-- added import (useGetNotifications)
import PageWrapper from 'common/components/PageWrapper';
import { useTranslation } from 'react-i18next';
import NotificationTab from 'modules/notification/components/notificationTab';


export default function NotificationPage(): JSX.Element {
    const { t } = useTranslation('notification');

    const LINKS = [
        {
            name: t('settings.short'),
        },
        {
            name: t('settings'),
            href: '/dashboard/notifications/settings',
        },
        {
            name: t('title'),
        },
    ];

    return (
        <PageWrapper
            titleHead={t('title')}
            title={t('title')}
            links={LINKS}
        >
            <NotificationTab />
        </PageWrapper>
    );
}